import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { EmptyState, QueueFlyoutTab, DataTable } from 'components';
import { AppLayout, LeftNavLayout } from 'containers';
import * as styles from './CommissionsView.scss';
var CommissionsView = (_dec = connect(function (state) {
  return {
    commissionsAccount: state.billing.commissionsAccount,
    transfers: state.billing.connectAccountTransfers ? state.billing.connectAccountTransfers : [],
    isLoadingTransfers: state.billing.loadingAccountTransfers,
    commissionsBalance: state.billing.commissionsBalance,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(CommissionsView, _Component);

  var _super = _createSuper(CommissionsView);

  function CommissionsView() {
    var _this;

    _classCallCheck(this, CommissionsView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getNextWeekday", function (dayPosition) {
      if (moment().isoWeekday() <= dayPosition) {
        return moment().isoWeekday(dayPosition);
      }

      return moment().add(1, 'weeks').isoWeekday(dayPosition);
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountBalance", function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'available';
      var commissionsBalance = _this.props.commissionsBalance;

      if (!commissionsBalance) {
        return 0;
      }

      var data = commissionsBalance[type];
      var total = 0;
      data.forEach(function (obj) {
        total += parseInt(obj.amount);
      });
      return total;
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format);

    return _this;
  }

  _createClass(CommissionsView, [{
    key: "render",
    value: function render() {
      var bankAccount = this.props.commissionsAccount && this.props.commissionsAccount.connectAccount && this.props.commissionsAccount.connectAccount.bank_accounts && this.props.commissionsAccount.connectAccount.bank_accounts.data.length > 0 ? this.props.commissionsAccount.connectAccount.bank_accounts.data[0] : null;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.columnWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Bank Account"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Name:"), " ", bankAccount ? bankAccount.account_holder_name : null), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Details:"), ' ', bankAccount ? "".concat(bankAccount.bank_name, " - \u2022\u2022\u2022\u2022 ").concat(bankAccount.last4) : ''))), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Payouts"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Next Payout Date:"), ' ', this.getNextWeekday(3).format('MMMM Do[,] YYYY')), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Pending Commissions:"), ' ', this.formatCurrency(this.getAccountBalance('pending') / 100.0)), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Next Payout Amount:"), ' ', this.formatCurrency(this.getAccountBalance() / 100.0))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: true,
        label: 'History',
        key: 0,
        style: {
          padding: '5px 16px'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.transfers.length ? /*#__PURE__*/React.createElement(DataTable, {
        hideSort: true,
        headerFields: [{
          name: 'Client',
          key: 'client'
        }, {
          name: 'Charge',
          key: 'chargeAmount'
        }, {
          name: 'Commission',
          key: 'commissionAmount'
        }, {
          name: 'Date',
          key: 'date'
        }, {
          name: 'ID',
          key: 'id'
        }],
        data: this.props.transfers.map(function (obj) {
          return {
            id: obj.id,
            client: obj.Organization ? obj.Organization.name : 'Unknown',
            commissionAmount: new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: obj.currency.toUpperCase(),
              minimumFractionDigits: 2
            }).format(parseFloat(obj.amount) / 100.0),
            chargeAmount: obj.Deposit ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: obj.currency.toUpperCase(),
              minimumFractionDigits: 2
            }).format(parseFloat(obj.Deposit.totalCharged) / 100.0) : '-',
            date: moment(new Date(parseInt(obj.created) * 1000)).format('MMMM Do[,] YYYY h:mm a')
          };
        }),
        fixedHeader: true,
        height: 500,
        isLoading: this.props.isLoadingTransfers
      }) : /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: '0 auto',
          maxWidth: 700,
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray2,
          marginBottom: 0
        }
      }, "No commissions yet."), /*#__PURE__*/React.createElement("i", {
        className: 'text icon ion-ios-filing-outline',
        style: {
          color: this.props.theme.colors.gray3,
          fontSize: 95
        }
      }), /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray2,
          marginTop: 0
        }
      }, "Likeable Local will automatically deposit a portion of the money your customers spend on Facebook advertisements into your bank account every Wednesday.")))))));
    }
  }]);

  return CommissionsView;
}(Component)) || _class);
export { CommissionsView as default };